  import {
    FETCH_APPOINTMENTDETAILS_DATA,
    FETCH_APPOINTMENTDETAILS_DATA_SUCCESS,
    FETCH_APPOINTMENTDETAILS_DATA_FAILURE,
  } from "../actions/appointments/types";
  
  const initialState = {
    loading: false,
    hasErrors: false,
    deepLinkAppointmentInfo : null,
  };
  
  export default function deeplinkAppointmentReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_APPOINTMENTDETAILS_DATA:
          return { ...state, loading: action.isLoading };
      case FETCH_APPOINTMENTDETAILS_DATA_SUCCESS:
          return {deepLinkAppointmentInfo: action.data, loading: action.isLoading, hasErrors: action.error };
      case FETCH_APPOINTMENTDETAILS_DATA_FAILURE:
          return { ...state, loading: action.isLoading, hasErrors: action.errordata };
      default:
        return state;
    }
  }